import { Outlet } from "react-router";

export default function HomeLayout() {
  return (
    <div>
      <div className="">
        <Outlet />
      </div>
    </div>
  );
}
